var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"button",attrs:{"to":"/contact-us"}},[_c('span',[_vm._v("Talk to us")])])}
var staticRenderFns = []

export { render, staticRenderFns }